module.exports = __webpack_public_path__ + "static/media/icn_facebook.0833eab8.svg";